export default {
    'diagram9-3a1': {
        'diagram-number': '9.',
        'elements': {
            'one': 'Uncertainty in government policy paralyzes, making businesses and consumers less sensitive to outside forces',
            'two': 'The paralysis results in productive firms being slow to expand, and unproductive firms slow to contract',
            'three': 'Thus resources don’t get reallocated, shutting down the primary mechanism for increasing productivity',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a1/diagram9/i18n/en.js